/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import BaseModal from 'src/common/components/Modal';
import { makeStyles, Grid } from '@material-ui/core';
import FullTable from 'src/common/components/FullTable';
import { columns } from './utils/list_data';
import CustomButton from 'src/common/components/CustomButton';
import { attendanceAPI } from 'src/api/modules/attendance';
import notice from 'src/common/components/Notice';
import { formatDate } from 'src/utils/dates';
import { createR } from 'src/utils/UniqueIdGenerator';

const useStyles = makeStyles({
	subTitle2: {
		fontSize: '15px',
		padding: '0px 0px 10px 0px',
	},
	containerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
	},
});

const AttendanceModal = ({ open, setOpen, idSession }) => {
	const classes = useStyles();
	const [allSelected, setAllSelected] = useState([{}]);
	const [usersForExcel, setUsersForExcel] = useState([{}]);
	const [users, setUsers] = useState([]);
	const markBtnLabel =
		allSelected.length === users.length ? 'Desmarcar todos' : 'Marcar todos';

	useEffect(() => {
		getUsers();
	}, []);

	const onCheckboxPublicar = (id) => {
		if (allSelected.includes(id)) {
			setAllSelected(allSelected.filter((delId) => delId != id));
		} else {
			setAllSelected([...allSelected, id]);
		}
	};

	const markAll = () => {
		if (allSelected.length === users.length) {
			//Select All
			setAllSelected('');
		} else {
			//Unselect all
			setAllSelected(users.map((user) => user.id_table));
		}
	};

	const getUsers = () => {
		if (idSession !== undefined) {
			attendanceAPI
				.get(idSession)
				.then((response) => {
					let usersAttended = [];
					let newUsersExcel = [];
					let newUsers = [];

					response.forEach((item) => {
						const newItem = { ...item };
						//We assigned a unique ID instance (just for the table) for each item with length 16 (could be less)
						newItem.id_table = createR(16);
						newUsers.push(newItem);

						if (newItem.asistio == true) {
							usersAttended.push(newItem.id_table);
						}
						newUsersExcel.push({
							usuario: newItem.usuario,
							id_table: newItem.asistio === true ? 'SI' : 'NO',
						});
					});
					setAllSelected(usersAttended);
					setUsersForExcel(newUsersExcel);
					setUsers(newUsers);
				})
				.catch(() => {
					notice('Ha ocurrido un problema con la solicitud', 'info');
				});
		}
	};
	const post = () => {
		let allList = [...new Set(allSelected)];
		let newArray = [];

		users.forEach((item) => {
			newArray.push({
				id: item.id,
				idUsuario: item.idUsuario,
				asistio: allList.includes(item.id_table),
			});
		});

		attendanceAPI
			.putAttendance(newArray)
			.then((response) => {
				notice('Se ha actualizado la lista de asistencia con éxito', 'success');
				getUsers();
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'error');
			});
	};
	return (
		<BaseModal
			open={open}
			mainText="Asistencia a la Sesión"
			onClose={() => setOpen(false)}
			onCancel={() => setOpen(false)}
			maxWidth="md"
			onConfirm={() => post()}
			confirmLabel="Actualizar Asistencia"
		>
			<Grid container className={classes.root} spacing={2}>
				<div style={{ width: '100%' }}>
					<FullTable
						title="Usuarios Invitados a la Sesión"
						keyField="id_table"
						items={users}
						itemsOthers={usersForExcel}
						columns={columns(onCheckboxPublicar, allSelected)}
						ExcelPersonalized={`Asistencia_${formatDate('P p')}.xls`}
					/>
					<div className={classes.containerButtons}>
						<CustomButton
							mainText={markBtnLabel}
							onClick={markAll}
							className={'mb-5'}
						/>
					</div>
				</div>
			</Grid>
		</BaseModal>
	);
};

export default AttendanceModal;
